/* eslint-disable import/no-unresolved */
import Vue from 'vue';
import Vuex from 'vuex';

// import createPersistedState from 'vuex-persistedstate';
// eslint-disable-next-line import/no-cycle
import auth from './auth.module';
// eslint-disable-next-line import/no-cycle
import user from './user.module';
import data from './data.module';
import logs from './logs.module';
import calendar from './calendar.module';
import reservations from './reservations.module';
import roomtypes from './roomtypes.module';
import rateplans from './rateplans.module';
import mealplans from './mealplans.module';
import settings from './settings.module';
import policies from './policies.module';
import nearby from './nearby.module';
import neogallery from './neogallery.module';
import channels from './channels.module';
import contacts from './contacts.module';
import channelsHealth from './channelsHealth.module';
import channel from './channel.module';
import marketPlace from './marketPlace.module';
import facilities from './facilities.module';
import invoices from './invoices.module';
import description from './description.module';
import systems from './systems.module';
import system from './system.module';
import roles from './roles.module';
import groups from './groups.module';
import users from './users.module';
import dashboard from './dashboard.module';
import payments from './payments.module';
import extras from './extras.module';
import performance from './performance.module';
import translation from './translation.module';
import widget from './widget.module';
import cultbookingSettings from './cultbooking-settings.module';
import partner from './partner.module';
import pages from './pages.module';
import errorReport from './error.module';
import activity from './activity.module';
import webhooks from './webhooks.module';
import messages from './messages.module';
import contracts from './contracts.module';
import promotions from './promotions.module';
import restrictions from './restrictions.module';
import properties from './properties.module';
import businessCategories from './business-categories.module';
import explanationBox from './explanationBox.module';
import onlinePresence from './online-presence.module';
import consultants from './consultants.module';
import reports from './reports.module';
import events from './events.module';
import mediaCategories from './mediaCategories.module';

Vue.use(Vuex);

const modules = {
  auth,
  user,
  data,
  logs,
  calendar,
  reservations,
  roomtypes,
  rateplans,
  mealplans,
  settings,
  policies,
  nearby,
  neogallery,
  channels,
  marketPlace,
  contacts,
  channelsHealth,
  channel,
  facilities,
  invoices,
  description,
  systems,
  system,
  roles,
  groups,
  users,
  payments,
  dashboard,
  extras,
  performance,
  translation,
  widget,
  cultbookingSettings,
  partner,
  pages,
  errorReport,
  activity,
  webhooks,
  messages,
  contracts,
  promotions,
  restrictions,
  properties,
  businessCategories,
  explanationBox,
  onlinePresence,
  consultants,
  reports,
  events,
  mediaCategories,
};

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    pageTitle: null,
    pageBreadcrumb: null,
    pageBreadcrumbSub: null,
    routePrefix: null,
    sidebar: false,
    centered: false,
    stretch: false,
    appLoading: true,
    mobileShown: false,
    collapsed: false,
    // translation: null,
  },
  getters: {
    pageTitle: (state) => state.pageTitle || 'Home',
    pageBreadcrumb: (state) => state.pageBreadcrumb,
    pageBreadcrumbSub: (state) => state.pageBreadcrumbSub,
    sidebar: (state) => (state.sidebar != null ? state.sidebar : true),
    centered: (state) => (state.centered != null ? state.centered : false),
    stretch: (state) => (state.stretch != null ? state.stretch : false),
    appLoading: (state) => state.appLoading,
    routePrefix: (state) => state.routePrefix,
    mobileShown: (state) => state.mobileShown,
    collapsed: (state) => state.collapsed,
    // getTranslation: (state) => state.translation,
  },
  mutations: {
    pageBreadcrumb(state, breadcrumb) {
      state.pageBreadcrumb = breadcrumb;
    },
    pageBreadcrumbSub(state, pageBreadcrumbSub) {
      state.pageBreadcrumbSub = pageBreadcrumbSub;
    },
    pageTitle(state, title) {
      state.pageTitle = title;
    },
    sidebar(state, enabled) {
      state.sidebar = enabled;
    },
    centered(state, enabled) {
      state.centered = enabled;
    },
    stretch(state, enabled) {
      state.stretch = enabled;
    },
    appLoading(state, payload) {
      state.appLoading = payload;
    },
    routePrefix(state, payload) {
      state.routePrefix = payload;
    },
    mobileShown(state, payload) {
      state.mobileShown = payload;
    },
    collapsed(state, payload) {
      state.collapsed = payload;
    },
    // getTranslation(state, trans) {
    //   state.translation = trans;
    // },
  },
  actions: {
    clearErrors({ commit }) {
      Object.keys(modules)
        .forEach((module) => commit(`${module}/clearErrors`));
    },
  },
  modules,
  // plugins: [createPersistedState({ storage: window.sessionStorage })],
});

const initialState = JSON.parse(JSON.stringify(store.state));

store.resetState = () => {
  store.replaceState(JSON.parse(JSON.stringify(initialState)));
};

export default store;
